import i18n from "@/i18n";

export default [
  {
    path: "/unterricht",
    name: "UnterrichtDashboard",
    meta: {
      title: String(i18n.t("sidebar.dashboard")),
      trans: "sidebar.dashboard",
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/UnterrichtDashboard/UnterrichtDashboard.vue"),
  },
];
